export default {
  data() {
    return {
      formDocumentRevision: {
        stat: "P", // current status
        sec: "S1", // security level
        type: "BP", // type of document
        ref: "", // reference for the docuemn
        com: "", // comment or justification for the rev or mod
        nmod: 0, // maximum recorded mod for this revision
        nrev: 0, // total nmber oftranstion chnages
        modc: "", // mod last
        modm: "", // mod maximum
        modcc: "", // mod comment, why chnage (pre defined)
        modmc: "", // mod comment for highest (max) rev
        r1: 0, // transformative document change
        r2: 0, // rev refer to description
        r3: 0, // rev refer to description
        uname: "", // first name and last name, or title
        uemail: "", // user emauk
        udid: "" // user did option
      }
    };
  }
};
